import { Table, type TableColumnsType } from 'antd';
import clsx from 'clsx';
import { StatusTag } from 'components';
import { STATUS_LIST, StatusDataType } from 'const/statusDefinitions';
import { getDossierStatusColor } from 'const/statutsDossier';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DossierStatus } from 'types/Dossier';

interface StatusTableProps {
  className?: string;
}

export default function StatusTable({ className = '' }: StatusTableProps) {
  const { t } = useTranslation();

  const statutsDossiers: StatusDataType[] = STATUS_LIST.map(
    (status, index) => ({
      key: index.toString(),
      definition: t(`statuts_dossiers_definitions:${status}`),
      status,
    }),
  );

  const columsStatusDossiers: TableColumnsType<StatusDataType> = [
    {
      title: t('glossaire:title_statuts_dossier'),
      key: 'status',
      dataIndex: 'status',
      width: '50%',
      render: (_, text) => (
        <StatusTag
          status={t(`statuts_dossier:${text.status}`)}
          color={getDossierStatusColor(
            DossierStatus[text.status as keyof typeof DossierStatus],
          )}
        />
      ),
    },
    {
      title: t('glossaire:definition'),
      key: 'definition',
      dataIndex: 'definition',
      width: '50%',
    },
  ];

  return (
    <Table
      columns={columsStatusDossiers}
      dataSource={statutsDossiers}
      pagination={false}
      bordered
      className={clsx(
        'separate-rows-table blue-header-table radius-sm',
        className,
      )}
    />
  );
}
